import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm font-bold" }
const _hoisted_2 = { class: "text-sm text-gray-500" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "name", "checked"]

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'DetailSwitch',
  props: {
    id: {
        type: String,
        default: null
    },
    name: {
        type: String,
        default: null
    },
    title: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    },
    checked: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props
const isChecked = ref(props.checked);
const check = () => {
    isChecked.value = !isChecked.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = ($event: any) => (check())),
    class: _normalizeClass(["space-y-2", __props.disabled ? 'pointer-events-none cursor-not-allowed' : 'cursor-pointer'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["col-span-1 flex py-5 px-4 rounded-lg items-center gap-10 justify-between", isChecked.value ? 'bg-[#F9FAFB]': ''])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(__props.title), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.description), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: __props.id,
          class: "inline-flex relative items-center cursor-pointer"
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            value: "",
            id: __props.id,
            name: __props.name,
            class: "sr-only peer",
            checked: isChecked.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (check()))
          }, null, 8, _hoisted_4),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-8 h-5 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-sd-info peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:top-1/2 after:-translate-y-1/2 after:transition-all focus:outline-none dark:border-gray-600 peer-checked:bg-primary-700" }, null, -1))
        ], 8, _hoisted_3)
      ])
    ], 2)
  ], 2))
}
}

})